import React from 'react';
import { CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons';

interface CalendarEventsNavProps {
	title: string;
	onPrev: () => void;
	onNext: () => void;
}

export const CalendarEventsNav: React.FC<CalendarEventsNavProps> = ({ title, onPrev, onNext }) => {
	return (
		<div className="calendar-title-nav flex items-center justify-between mb-2">
			<button
				onClick={onPrev}
				className="nav-btn w-10 h-10 flex items-center justify-center rounded-lg bg-white border border-gray-200 text-2xl hover:bg-violet-50"
			>
				<CaretLeftOutlined />
			</button>
			<h2 className="calendar-title text-xl font-bold text-gray-900">{title}</h2>
			<button
				onClick={onNext}
				className="nav-btn w-10 h-10 flex items-center justify-center rounded-lg bg-white border border-gray-200 text-2xl hover:bg-violet-50"
			>
				<CaretRightOutlined />
			</button>
		</div>
	);
};
